import "../index.css";

export default function About() {
  return (
    <section id="about" className="about-section">
      {/* WHO WE ARE */}
      <div className="about-intro">
        <h2>О насe</h2>
        <p>
         Имея более 10 лет опыта в сфере логистики, Gxpress Solutions предоставляет персонализированные решения по управлению цепочками поставок для компаний, осуществляющих свою деятельность на различных международных рынках.
        </p>

        <p>
          Наша штаб-квартира находится в Индии, а деятельность компании осуществляется через обширную глобальную сеть:
        </p>

        <div className="locations">
          <span>Индия (Головной офис)</span>
          <span>Великобритания</span>
          <span>США</span>
          <span>ОАЭ</span>
        </div>
      </div>

      {/* WHAT WE DO */}
      <div className="services-grid">
        <div className="service-card">
          <h3>Сквозная цепь поставок</h3>
          <ul>
            <li>Перевозка "из порта в порт"</li>
            <li>Перевозка "от двери до порта"</li>
            <li>Перевозка "от порта до двери"</li>
            <li>Поставка "от двери до двери"/ "из рук в руки"</li>
          </ul>
        </div>

        <div className="service-card">
          <h3>Способы перевозки</h3>
          <ul>
            <li>Воздушные перевозки</li>
            <li>Морские перевозкиt</li>
          </ul>
        </div>

        <div className="service-card">
          <h3>Поддержка электронной торговли и продавцов</h3>
          <ul>
            <li>Отправки FBA для Amazon — организация поставок на склады Amazon по программе FBA.</li>
            <li>Индивидуальные отправки под заказ — доставка товаров напрямую покупателям.</li>
            <li> Логистика для верифицированныхпродавцов —комплексныерешениядля проверенных продавцовнамаркетплейсах.</li>
            <li>Помощь в выходе на рынок—консультации и логистическаяподдержка при запуске продажвновых странах.</li>
          </ul>
        </div>
      </div>

      {/* RUSSIA SHIPMENTS SECTION */}
      <div className="russia-section">
        <h2>Услуги по доставке грузоввРоссию</h2>
        <p className="section-subtitle">
          Мы предлагаем полный спектрлогистических решений дляотправокв Россию, обеспечивая безупречнуюкоординацию на всех этапах—отпункта отправления до конечнойдоставки.
        </p>

        <div className="russia-grid">
          <ul>
            <li>Экспортная обработка в странеотправления</li>
            <li>Поддержка в таможенномоформлении (в стране отправленияиназначения)</li>
            <li>Помощь в подготовке документации</li>
            <li>Обработка груза в страненазначения</li>
            <li>Координация доставки последнеймили</li>
          </ul>
        </div>
      </div>

      {/* INDUSTRIES SECTION */}
      <div className="industries-section">
        <h2>Отрасли, которые мыобслуживаем:</h2>

        <div className="industries-grid">
          <span>Кожаные изделия</span>
          <span>Текстиль и одежда</span>
          <span>Фармацевтическая продукция</span>
          <span>Инструменты и оборудование</span>
          <span>Автомобильные запчасти</span>
          <span>Потребительские товарыиз Индии</span>
        </div>
      </div>

      {/* WHY CHOOSE US SECTION */}
      <div className="why-section">
        <h2>Почему стоит выбрать GxpressSolutions</h2>

        <div className="why-grid">
          <ul>
            <li>Доказанный опыт в сферемеждународных грузоперевозок</li>
            <li>Широкая сеть надёжных партнёровпо всему миру</li>
            <li>Адаптируемые форматысотрудничества</li>
            <li>Открытость и прозрачностьнавсехэтапах перевозки</li>
            <li>Строгое соблюдение таможенныхиправовых норм</li>
            <li>Оптимальное соотношениеценыикачества логистических услуг</li>
          </ul>
        </div>

        <h3 className="tagline"> Один партнёр. Полный комплекслогистических услуг.</h3>
      </div>
    </section>
  );
}
